import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fa2c575c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "section-2"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12 col-md-8" }
const _hoisted_5 = { class: "description-title" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "description-item" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "name text-overflow" }
const _hoisted_10 = {
  key: 0,
  class: "col-12 col-md-4"
}
const _hoisted_11 = ["src"]

import { IProduct } from '@/types/product';
  import { computed } from 'vue';

  interface IProps {
    product: IProduct;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    product: null
  },
  setup(__props: any) {

const props = __props as {
    product: IProduct;
  }

  

  const descriptions = computed(() => {
    return [
      {
        title: 'What you can recycle',
        icon: require('@/assets/icon/icon-correct.png'),
        items: props.product.recyclable_list
      },
      {
        title: 'This box does not acce',
        icon: require('@/assets/icon/icon-wrong.png'),
        items: props.product.unrecyclable_list
      }
    ].filter(item => item.items && item.items.length);
  });


return (_ctx: any,_cache: any) => {
  return (_unref(descriptions).length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(descriptions), (description, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "box-description"
                }, [
                  _createElementVNode("h4", _hoisted_5, _toDisplayString(description.title), 1),
                  _createElementVNode("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(description.items, (item, itemIndex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: itemIndex,
                        class: "col-6"
                      }, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("img", {
                            src: description.icon
                          }, null, 8, _hoisted_8),
                          _createElementVNode("span", _hoisted_9, _toDisplayString(item), 1)
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              }), 128))
            ]),
            (__props.product.recyclable_image)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("img", {
                    class: "section-image",
                    src: __props.product.recyclable_image.url,
                    alt: ""
                  }, null, 8, _hoisted_11)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})